import * as Types from '../graphqlBase.generated';

import { TypedDocumentString } from "~/gql/graphqlBase.generated";
import { baseApiWithGraphql } from '~/services/baseApi';
import type { GraphqlEndpointBuilder } from '~/services/baseApi';
export type StopContactTextsMutationVariables = Types.Exact<{
  input: Types.StopContactTextsInput;
}>;


export type StopContactTextsMutation = { __typename?: 'Mutation', stopContactTexts: { __typename?: 'ContactTextConsentPayload', textConsent?: { __typename?: 'ContactTextConsentData', contactId: string, phoneNumber: string, status: Types.ContactTextConsentStatus, requestExpiresAt?: Types.TDateISO | null, stoppedAt?: Types.TDateISO | null, repliedStopAt?: Types.TDateISO | null, lastTextFailed: boolean } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type RecordContactTextConsentMutationVariables = Types.Exact<{
  input: Types.RecordContactTextConsentInput;
}>;


export type RecordContactTextConsentMutation = { __typename?: 'Mutation', recordContactTextConsent: { __typename?: 'ContactTextConsentPayload', textConsent?: { __typename?: 'ContactTextConsentData', contactId: string, phoneNumber: string, status: Types.ContactTextConsentStatus, requestExpiresAt?: Types.TDateISO | null, stoppedAt?: Types.TDateISO | null, repliedStopAt?: Types.TDateISO | null, lastTextFailed: boolean } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };


export const StopContactTextsDocument = new TypedDocumentString(`
    mutation StopContactTexts($input: StopContactTextsInput!) {
  stopContactTexts(input: $input) {
    textConsent {
      ...ContactTextConsent
    }
    errors {
      code
      message
    }
  }
}
    fragment ContactTextConsent on ContactTextConsentData {
  contactId
  phoneNumber
  status
  requestExpiresAt
  stoppedAt
  repliedStopAt
  lastTextFailed
}`);
export const RecordContactTextConsentDocument = new TypedDocumentString(`
    mutation RecordContactTextConsent($input: RecordContactTextConsentInput!) {
  recordContactTextConsent(input: $input) {
    textConsent {
      ...ContactTextConsent
    }
    errors {
      code
      message
    }
  }
}
    fragment ContactTextConsent on ContactTextConsentData {
  contactId
  phoneNumber
  status
  requestExpiresAt
  stoppedAt
  repliedStopAt
  lastTextFailed
}`);
const injectedRtkApiEndpoints = (build: GraphqlEndpointBuilder) => ({
    StopContactTexts: build.mutation<StopContactTextsMutation, StopContactTextsMutationVariables>({
      query: (variables) => ({ document: StopContactTextsDocument, variables })
    }),
    RecordContactTextConsent: build.mutation<RecordContactTextConsentMutation, RecordContactTextConsentMutationVariables>({
      query: (variables) => ({ document: RecordContactTextConsentDocument, variables })
    }),
});

const injectedRtkApi = baseApiWithGraphql.injectEndpoints({ endpoints: injectedRtkApiEndpoints });

export type GeneratedEndpointDefinitions = ReturnType<typeof injectedRtkApiEndpoints>;

export { injectedRtkApi as api };
export const { useStopContactTextsMutation, useRecordContactTextConsentMutation } = injectedRtkApi;
